import {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
} from './apiTypes';
import { emptyApiSlice } from './emptyApiSlice';

export const stripeApiSlice = emptyApiSlice.injectEndpoints({
  endpoints: builder => ({
    createCheckoutSession: builder.mutation<
      CreateCheckoutSessionResponse,
      CreateCheckoutSessionRequest
    >({
      query: body => ({
        url: '/billing/create-embedded-subscription',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateCheckoutSessionMutation } = stripeApiSlice;
